// extracted by mini-css-extract-plugin
module.exports = {"AnswerItem":"AnswerItem_AnswerItem__24UG1","success":"AnswerItem_success__1i2QQ","error":"AnswerItem_error__1nhFt"};